import { render, staticRenderFns } from "./ConfirmationCommentModal.vue?vue&type=template&id=76b889e2&"
import script from "./ConfirmationCommentModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmationCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports